import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Typography } from '@mui/material';
import axios from 'axios';
import Page from '../components/Page';
import Iconify from '../components/Iconify';
import AppWidgetSummary from '../sections/@dashboard/app/AppWidgetSummary'; // Ensure correct import path
import AppCurrentVisits from '../sections/@dashboard/app/AppCurrentVisits'; // Import the pie chart component
import AppConversionRates from '../sections/@dashboard/app/AppConversionRates'; // Import the bar chart component


// ----------------------------------------------------------------------

export default function DashboardApp() {
  const theme = useTheme();
  const [stats, setStats] = useState({
    
    totalIndividuals: 0,
    totalLifeMembers: 0,
    totalSeniorCitizens: 0,
    totalStudents: 0,
    totalIndustries: 0,
    totalInstitutions: 0,
    totalTradeUnions: 0,
    totalAssociations: 0
  });

  // Fetch stats from the API
  const fetchStats = async () => {
    try {
      const response = await axios.get('https://form.cpccbe.org/api/stats/get-stats'); // Adjust the endpoint as necessary
      setStats(response.data);
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  // Data for pie chart
  const pieChartData = [
    { label: 'Individuals', value: stats.totalIndividuals },
    { label: 'Life Members', value: stats.totalLifeMembers },
    { label: 'Senior Citizens', value: stats.totalSeniorCitizens },
    { label: 'Students', value: stats.totalStudents },
    { label: 'Industries', value: stats.totalIndustries },
    { label: 'Institutions', value: stats.totalInstitutions },
    { label: 'Trade Unions', value: stats.totalTradeUnions },
    { label: 'Associations', value: stats.totalAssociations }
  ];

  // Data for bar chart
  const barChartData = [
    { label: 'Total Individuals', value: stats.totalIndividuals },
    { label: 'Total Life Members', value: stats.totalLifeMembers },
    { label: 'Total Senior Citizens', value: stats.totalSeniorCitizens },
    { label: 'Total Students', value: stats.totalStudents },
    { label: 'Total Industries', value: stats.totalIndustries },
    { label: 'Total Institutions', value: stats.totalInstitutions },
    { label: 'Total Trade Unions', value: stats.totalTradeUnions },
    { label: 'Total Associations', value: stats.totalAssociations }
  ];

  return (
    <Page title="Dashboard">
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Hi, Welcome back
        </Typography>

        <Grid container spacing={3}>
     

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Total Individuals" total={stats.totalIndividuals} color="info" icon={'mdi:account'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Total Life Members" total={stats.totalLifeMembers} color="success" icon={'mdi:heart'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Total Senior Citizens" total={stats.totalSeniorCitizens} color="error" icon={'mdi:account-star'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Total Students" total={stats.totalStudents} icon={'mdi:school'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Total Industries" total={stats.totalIndustries} color="info" icon={'mdi:factory'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Total Institutions" total={stats.totalInstitutions} color="success" icon={'mdi:university'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Total Trade Unions" total={stats.totalTradeUnions} color="warning" icon={'mdi:gavel'} />
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Total Associations" total={stats.totalAssociations} color="secondary" icon={'mdi:handshake'} />
          </Grid>

          {/* Pie Chart */}
          <Grid item xs={12} md={6}>
            <AppCurrentVisits
              title="Category Distribution"
              subheader="Distribution of members by category"
              chartData={pieChartData}
              chartColors={[
                theme.palette.primary.main,
                theme.palette.info.main,
                theme.palette.success.main,
                theme.palette.error.main,
                theme.palette.warning.main,
                theme.palette.secondary.main,
                theme.palette.chart.red[0],
                theme.palette.chart.blue[0],
              ]}
            />
          </Grid>

          {/* Bar Chart */}
          <Grid item xs={12} md={6}>
            <AppConversionRates
              title="User Statistics"
              subheader="Overview of different user categories"
              chartData={barChartData}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
